import { render, staticRenderFns } from "./RecReportSection.vue?vue&type=template&id=850a21d8&scoped=true"
import script from "./RecReportSection.vue?vue&type=script&lang=js"
export * from "./RecReportSection.vue?vue&type=script&lang=js"
import style0 from "./RecReportSection.vue?vue&type=style&index=0&id=850a21d8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "850a21d8",
  null
  
)

export default component.exports